/* global document */
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Switch } from 'react-router-dom';
import PaymentProcessingInFramePage from './pages/PaymentProcessingInFramePage';
import store, { history } from './store';
// import registerServiceWorker from './registerServiceWorker';
import { includesPolyfill, ArrayFindPolyfill, ArrayFromPolyfill } from './services/polyfills';

import App from './App';
import AdminPage from './pages/AdminPage/';
import RetrieveCustomer from './pages/AdminPage/RetrieveCustomer';
import IPIDPage from './pages/IPIDPage';


// apply polyfills
includesPolyfill();
ArrayFindPolyfill();
ArrayFromPolyfill();

const target = document.getElementById('root');

const routes = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/processingPayment" component={PaymentProcessingInFramePage} />
        <Route exact path="/admin" component={AdminPage} />
        <Route exact path="/admin/retrievecustomer" component={RetrieveCustomer} />
        <Route exact path="/ssTerms" component={IPIDPage} />
        <Route component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

ReactDOM.render(routes(), target);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js